


















import {Vue, Component} from 'vue-property-decorator';
import {MediumPostInterface} from '@/interfaces/MediumPost';
import MediumPost from '@/components/MediumPost.vue';

@Component({
    name: 'MediumPosts',
    components: {MediumPost},
})
export default class MediumPosts extends Vue {
    public mediumPosts: MediumPostInterface[] = [
        {
            title: 'Nuxt.js over Vue.js: when should you use it and why',
            description: 'Nuxt.js is a frontend framework built upon Vue.js that offers great development features such as server side rendering, automatically generated routes, improved meta tags managing and SEO improvement.',
            href: 'https://medium.com/distant-horizons/nuxt-js-over-vue-js-when-should-you-use-it-and-why-e25c18adf14',
            image: 'nuxt.jpg',
        },
        {
            title: 'Vue.js: how we started and what are we using it for',
            description: 'In the last 2 years, we have built several web applications with Vue.js — from a banking fraud app and an internal time tracking tool, all the way to interactive Kinect applications and many more.',
            href: 'https://medium.com/distant-horizons/vue-js-how-we-started-and-what-are-we-using-it-for-ce9c35f53245',
            image: 'vue.jpg',
        },
    ];
}
